import axios from 'axios'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

export const suggestedProductsAreLoading = () => {
	return {
		type: 'SUGGESTED_PRODUCTS_ARE_LOADING'
	}
}

export const suggestedProductsHasError = (bool)  => {
	return {
		type: 'SUGGESTED_PRODUCTS_HAS_ERROR',
		hasErrored: bool
	}
}

export const suggestedProductsSuccess = (data)  => {
	return {
		type: 'SUGGESTED_PRODUCTS_SUCCESS',
		data
	}
}

export function getSuggestedProducts(permalink = ''){
	return (dispatch, getState) => {
		dispatch(suggestedProductsAreLoading())

		let customerId = null;
		let topTierId = null;
		if (getState().user.customer){
			customerId = getState().user.customer.user.id
			topTierId = getState().user.customer.user.top_tier_id
		}
		
		let customerArgs = "";
		if(customerId) customerArgs += "?customerId=" + customerId;
		if(topTierId) customerArgs += "&topTierId=" + topTierId;

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }

		return axios.get(REACT_APP_API_URL + 'suggested-products/' + permalink + customerArgs, { headers: AUTH_HEADER })
		.then((response) => dispatch(suggestedProductsSuccess(response)))
		.catch((err) => {
			console.log('getSuggestedProducts error', err)
			dispatch(suggestedProductsHasError(err))
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/suggestedProducts.js